/* ==========================================================================
   YOSOU™ page interactions
   - Add to bag via Shopify Cart AJAX API (/cart/add.js)
   - Bag counter synced with the real cart (/cart.js)
   - Toast, FAQ accordion, newsletter form, mobile menu
   ========================================================================== */
(function () {
  'use strict';

  var scope = document.querySelector('.yo-scope');
  if (!scope) return;

  /* ---- Toast ---- */
  var toastEl = scope.querySelector('[data-yo-toast]');
  var toastTimer = null;

  function showToast(message) {
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 1800);
  }

  /* ---- Bag counter (real cart state) ---- */
  var bagCount = scope.querySelector('[data-yo-bag-count]');

  function updateBagCount(n) {
    if (!bagCount) return;
    var count = parseInt(n, 10);
    if (isNaN(count) || count < 0) count = 0;
    bagCount.textContent = String(count);
  }

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateBagCount(cart && cart.item_count);
        return cart;
      })
      .catch(function () {});
  }

  /* Initialize the counter from the real cart on page load */
  refreshCartCount();

  /* ---- Add to bag (Shopify Cart AJAX API) ---- */
  scope.querySelectorAll('.yo-add-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.getAttribute('data-item') || 'Item';
      var variantId = btn.getAttribute('data-variant-id');

      if (!variantId) {
        showToast('This item is not available yet');
        return;
      }

      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () {
          // NOTE: /cart/add.js returns the added line item, NOT the cart object —
          // it has no item_count. Re-read /cart.js to get the authoritative count.
          return refreshCartCount();
        })
        .then(function () {
          btn.textContent = 'Added \u2713';
          btn.classList.add('is-added');
          setTimeout(function () {
            btn.textContent = 'Add to bag';
            btn.classList.remove('is-added');
          }, 1400);

          showToast(item + ' added to bag');
        })
        .catch(function () {
          showToast('Could not add to bag \u2014 please try again');
        })
        .then(function () {
          btn.disabled = false;
        });
    });
  });

  /* ---- FAQ accordion (one open at a time) ---- */
  var faqItems = scope.querySelectorAll('.yo-faq-item');

  function closeItem(item) {
    item.classList.remove('is-open');
    var btn = item.querySelector('.yo-faq-q');
    var panel = item.querySelector('.yo-faq-a');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (panel) panel.style.maxHeight = null;
  }

  function openItem(item) {
    item.classList.add('is-open');
    var btn = item.querySelector('.yo-faq-q');
    var panel = item.querySelector('.yo-faq-a');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
  }

  faqItems.forEach(function (item) {
    var btn = item.querySelector('.yo-faq-q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (item.classList.contains('is-open')) {
        closeItem(item);
        return;
      }
      faqItems.forEach(closeItem);
      openItem(item);
    });
  });

  window.addEventListener('resize', function () {
    var open = scope.querySelector('.yo-faq-item.is-open');
    if (open) openItem(open);
  });

  /* ---- Newsletter form (front-end demo only) ---- */
  var newsForm = scope.querySelector('[data-yo-newsletter]');

  if (newsForm) {
    newsForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = newsForm.querySelector('input[type="email"]');
      if (input && !input.checkValidity()) {
        if (input.reportValidity) input.reportValidity();
        return;
      }
      showToast('Subscribed \u2014 thanks for signing up');
      newsForm.reset();
    });
  }

  /* ---- Mobile menu ---- */
  var menuBtn = scope.querySelector('[data-yo-menu-btn]');
  var mobileNav = scope.querySelector('[data-yo-mobile-nav]');

  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        menuBtn.setAttribute('aria-expanded', 'false');
      });
    });
  }
})();
